import {
  InteractionStepType,
  InteractionStepConfig,
  IndexedInteractionStepResponse,
  StepParamsForType,
  StepParamsForTypeWithStage,
} from '@scale/shared/types/chat';
import { ReviewLevel } from '@scale/shared-types';
import {
  isEmptyResponse,
  createDefaultResponseForFields,
} from '@scale/shared/textcollection/helpers';
import { IMultiTurnThreadHistory } from 'react-scale/components/scalers/tasks/ThreadedInteraction/ThreadHistory.interface';
import { isConditionallyVisible, isStepVisible } from '@scale/shared/chat/api';
import QIRTextCollectionConfigurationComponent from './QIRTextCollectionConfigurationComponent';
import { schema } from './validation';
import QIRTextCollectionPinnedViewComponent from './QIRTextCollectionPinnedViewComponent';
import QIRTextCollectionViewComponent from './QIRTextCollectionViewComponent';
import StepDescriptor from '../stepDescriptor/StepDescriptor';
import { registerStepDescriptor } from '../stepDescriptor/stepDescriptorContainer';

export class QIRTextCollectionDescriptor extends StepDescriptor<InteractionStepType.QIRTextCollection> {
  type = InteractionStepType.QIRTextCollection;
  title = InteractionStepConfig[InteractionStepType.QIRTextCollection].title;
  description = InteractionStepConfig[InteractionStepType.QIRTextCollection].description;

  ViewComponent = QIRTextCollectionViewComponent;
  PinnedViewComponent = QIRTextCollectionPinnedViewComponent;
  ConfigurationComponent = QIRTextCollectionConfigurationComponent;

  validationSchema = schema;

  isResponseValid(
    response: IndexedInteractionStepResponse,
    stepParams: StepParamsForTypeWithStage<InteractionStepType.QIRTextCollection>,
    history: IMultiTurnThreadHistory,
    reviewLevel?: ReviewLevel,
  ) {
    if (
      !isStepVisible(stepParams, reviewLevel) ||
      !isConditionallyVisible(
        stepParams,
        history.responses,
        response.index,
        history.threadParams.templateVariables,
        reviewLevel,
      )
    ) {
      return { canSubmit: true, submitTooltip: '' };
    }

    if (isEmptyResponse(response.context.response)) {
      return { canSubmit: false, submitTooltip: 'Some steps have not been completed.' };
    }

    return { canSubmit: true, submitTooltip: '' };
  }

  getResponseTemplatePaths(
    _stepParams: StepParamsForType<InteractionStepType.QIRTextCollection>,
    _history: IMultiTurnThreadHistory,
  ) {
    return [];
  }

  generateEmptyResponse(
    stepParams: StepParamsForType<InteractionStepType.QIRTextCollection>,
    history: IMultiTurnThreadHistory,
  ) {
    const emptyResponse = createDefaultResponseForFields(stepParams.params.fields);
    return {
      type: InteractionStepType.TextCollection,
      context: {
        response: emptyResponse,
      },
      output: history.getMostRecentResponse(),
    };
  }
}

registerStepDescriptor({
  type: InteractionStepType.QIRTextCollection,
  descriptor: new QIRTextCollectionDescriptor(),
});
